<div *ngIf="!!ecNetwork && canReadCommunity" class="ec-measures-container">
    <div fxLayout="row" class="ec-measures-time-panel">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px">
            <div class="txt-s-16-4">
                {{ 'Period'|i18n }}:
            </div>
            <div>
                <app-time-filter #timeFilter
                                 [profile]="TimeFilterProfile.MEASURES"
                                 [defaultType]="DEFAULT_TIME_FILTER.type"
                                 (timeFilterChange)="onSelectTimeFilter($event)">
                </app-time-filter>
            </div>
        </div>
        <mat-divider vertical class="time-divider"></mat-divider>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px">
            <div class="txt-s-16-4">
                {{ 'Temporal unit'|i18n }}:
            </div>
            <div>
                <mat-select app-small-select placeholder="{{'Temporal unit'|i18n}}"
                            [value]="timeResolution"
                            (selectionChange)="onSelectTimeResolution($event)">
                    <mat-option *ngFor="let res of timeResolutions" [value]="res">
                        {{ res.name|i18n }}
                    </mat-option>
                </mat-select>
            </div>
        </div>
        <mat-divider vertical class="time-divider"></mat-divider>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px">
            <div class="txt-s-16-4">
                {{ 'Synchronization'|i18n }}:
            </div>
            <div>
                <app-periodic-refresh [refreshIntervalName]="DEFAULT_REFRESH_INTERVAL"
                                      (intervalResetter)="refreshIntervalResetter = $event"
                                      (refreshTrigger)="onRefreshMeasures()"
                                      [title]="'Refresh interval'|i18n">
                </app-periodic-refresh>
            </div>
        </div>
        <div *ngIf="showUploadMeasuresButton && !isAdv"
             fxLayout="row" fxLayoutAlign="end center" fxFlex>
            <button app-ghost-button [disabled]="!canUpdateCommunity || hasNoProductionPod"
                    (click)="onclickUploadMeasures()">
                <app-icon name="fal-file-excel"></app-icon>
                {{ 'Upload Measures'|i18n }}
            </button>
            <app-icon *ngIf="hasNoProductionPod" class="ml-10 txt-p-16-4" name="fas-info-circle"
                      [title]="'In order to upload plant measurements, it is necessary to assign a production POD to it first.'|i18n"></app-icon>
        </div>
        <div *ngIf="showUploadGSEMeasuresButton && !isAdv"
             fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" fxFlex>
            <button app-ghost-button [disabled]="!canUpdateCommunity"
                    (click)="onclickUploadGSEMeasures()">
                <app-icon name="fal-file-excel"></app-icon>
                {{ 'Upload consolidated data'|i18n }}
            </button>
            <button app-ghost-button class="app-button-alert"
                    [disabled]="!canUpdateCommunity || !activeMonths.length || loadingEconomicsData"
                    (click)="onDeleteGSEData()">
                <app-icon name="fal-trash-alt"></app-icon>
                {{ 'Delete consolidated data'|i18n }}
            </button>
        </div>
    </div>
    <div fxLayout="row" fxLayoutGap="24px" class="ec-measures-main-panel mt-32">
        <div class="resource-tree">
            <app-ec-resource-tree [network]="ecNetwork"
                                  (selectionChange)="onSelectResource($event)">
            </app-ec-resource-tree>
        </div>
        <div fxLayout="column" class="ec-measures-charts-panel">
            <div *ngIf="resource?.type === EntityType.ENERGY_COMMUNITY && showDateWarning" fxLayout="row" fxLayoutAlign="center center"
                 fxLayoutGap="30px" economics-warning class="mt-30 padding-14">
                <app-icon icon-color-w name="fas-info-circle"></app-icon>
                <div>{{ 'Aggregated measures will be available after the community activation.'|i18n }}</div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="28px" class="ml-16 mt-36 mb-42 options-row">
                <div *ngIf="!options.length" fxLayout="row" fxLayoutAlign="center">
                    {{ 'No measures available'|i18n }}
                </div>
                <div *ngFor="let option of options" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
                    <mat-checkbox app-checkbox class="txt-p-14-4"
                                  [checked]="isOptionSelected(option)"
                                  (change)="onSelectOption(option, $event.checked)">
                    </mat-checkbox>
                    <div class="txt-p-14-4">{{ option.name|i18n }}</div>
                </div>
            </div>
            <div cdkDropList cdkDropListLockAxis="y" cdkDropListOrientation="vertical"
                 class="measure-charts" (cdkDropListDropped)="onMeasureDrop($event)">
                <div cdkDrag *ngFor="let meas of measures; let first=first let last=last" class="measure-box"
                     [ngClass]="{'mt-16': !first, 'mb-52': last}">
                    <div *appVar="meas.data|async as measData"
                         fxLayout="column" fxLayoutAlign="start stretch" class="measure">
                        <div cdkDragHandle fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="32px"
                             fxFlex class="measure-name mb-24">
                            <div class="txt-h-18-7">{{ meas.name|i18n }}</div>
                            <ng-container *ngIf="measData">
                                <!--
                                removed indication about data types
                                <div fxLayout="row" fxFlex fxLayoutAlign="start center" fxLayoutGap="10px"
                                     class="txt-p-16-4"
                                     *appVar="isDefined(meas.dataType) ? meas.dataType : measuresType as dataType">
                                    <ng-container *ngIf="isDefined(dataType) && !isEmpty(measData)"
                                                  [ngSwitch]="dataType">
                                        <ng-container *ngSwitchCase="MeasureDataType.STATISTICAL">
                                            <app-icon name="fal-chart-network"></app-icon>
                                            <span>{{'Statistical data'|i18n}}</span>
                                            <app-icon name="fas-info-circle"
                                                      [title]="'Energy data are estimated on GSE-defined statistical profiles and previous year\'s readings, in similar seasonality, and based on rate ranges'|i18n">
                                            </app-icon>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="MeasureDataType.MONITORED">
                                            <app-icon name="fal-radar"></app-icon>
                                            <span>{{'Monitored data'|i18n}}</span>
                                            <app-icon name="fas-info-circle"
                                                      [title]="'Based on energy data collected using smart meters'|i18n">
                                            </app-icon>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="MeasureDataType.HYBRID">
                                            <app-icon name="fal-shapes"></app-icon>
                                            <span>{{'Hybrid data'|i18n}}</span>
                                            <app-icon name="fas-info-circle"
                                                      [title]="'The aggregate data of this section are composed of monitored data and statistical data'|i18n">
                                            </app-icon>
                                        </ng-container>
                                    </ng-container>
                                </div>-->
                                <div fxLayout="column" *ngIf="!isEmpty(measData)" fxFlex fxLayoutAlign="center end">
                                    <div fxLayout="row" fxLayoutAlign="end center" *ngFor="let md of measData">
                                        <ng-container *ngIf="hasLegend(md, measData, meas.dataType)">
                                            <ng-container *ngIf="isMultilineChart(measData)">
                                                <span *ngIf="md.subName === MeasureAggregationDataSource.GSE"
                                                      [style]="{'background-color': md.consolidation_color}" class="legend-line-gse"></span>
                                                <ng-container *ngIf="md.subName !== MeasureAggregationDataSource.GSE">
                                                    <ng-container *ngIf="isEcSelected">
                                                        <span [style]="{'background-color': md.color}" class="legend-line"></span>
                                                        <span [style]="{'background-color': md.color}" class="legend-line dashed"></span>
                                                    </ng-container>
                                                    <ng-container *ngIf="!isEcSelected">
                                                        <span *ngIf="md.subName === MeasureAggregationDataSource.METER || md.subName === MeasureAggregationDataSource.FILE"
                                                              [style]="{'background-color': md.color}" class="legend-line"
                                                              [class.manual]="md.subName === MeasureAggregationDataSource.FILE"></span>
                                                        <span *ngIf="md.subName === MeasureAggregationDataSource.PROFILE"
                                                              [style]="{'background-color': md.color}" class="legend-line dashed"></span>
                                                        <span *ngIf="md.subName === MeasureAggregationDataSource.METER || md.subName === MeasureAggregationDataSource.FILE"
                                                              class="ml-10">{{ setTypeData(md) }}</span>
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                            <span *ngIf="md.sumValue != null && md.sumValue != undefined">&nbsp;
                                                <span class="txt-p-16-4">{{ ('Total'|i18n) + ': ' }}</span>
                                                <span class="txt-h-16-7">{{ md.sumValue|niceValue:md.uom }}</span>
                                            </span>
                                            <span *ngIf="md.meanValue != null && md.meanValue != undefined">
                                            &nbsp;
                                            <span class="txt-p-16-4">{{ ('Average'|i18n) + ': ' }}</span>
                                            <span class="txt-h-16-7">{{ md.meanValue|niceValue:md.uom }}</span>
                                        </span>
                                            <span *ngIf="md.maxValue != null && md.maxValue != undefined">
                                            &nbsp;
                                            <span class="txt-p-16-4">{{ ('Max'|i18n) + ': ' }}</span>
                                            <span class="txt-h-16-7">{{ md.maxValue|niceValue:md.uom }}</span>
                                        </span>
                                            <span *ngIf="md.minValue != null && md.minValue != undefined">
                                            &nbsp;
                                            <span class="txt-p-16-4">{{ ('Min'|i18n) + ': ' }}</span>
                                            <span class="txt-h-16-7">{{ md.minValue|niceValue:md.uom }}</span>
                                        </span>
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <ng-container *ngIf="!!measData && !isEmpty(measData)">
                            <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="1rem" class="mt-8">
                                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
                                    <div *ngIf="hasGSE(measData)" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.25rem"
                                         class="legend-toggle" [class.legend-hidden]="isLegendEntryHidden(meas.name, MeasureAggregationDataSource.GSE)"
                                         (click)="toggleOrigin(meas.name, MeasureAggregationDataSource.GSE)">
                                        <span [style]="{'background-color': measData[0].consolidation_color}"
                                              class="legend-line-gse"></span>
                                        <span>{{ 'Consolidated'|i18n }}</span>
                                        <ng-container *ngIf="isEcSelected">
                                            <app-icon name="fas-info-circle"
                                                      [title]="'Consolidated data is visible only if it has been provided for the entire selected period.'|i18n">
                                            </app-icon>
                                        </ng-container>
                                    </div>
                                    <div *ngIf="isEcSelected" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.25rem"
                                         class="legend-toggle" [class.legend-hidden]="isLegendEntryHidden(meas.name, MeasureAggregationDataSource.METER, MeasureAggregationDataSource.FILE)"
                                         (click)="toggleOrigin(meas.name, MeasureAggregationDataSource.METER, MeasureAggregationDataSource.FILE)">
                                        <span [style]="{'background-color': measData[0].color}" class="legend-line"></span>
                                        <ng-container *appVar="isDefined(meas.dataType) ? meas.dataType : measuresType as dataType">
                                            <ng-container *ngIf="dataType !== MeasureDataType.STATISTICAL">
                                                <span>{{ 'Monitored/hand-loaded'|i18n }}</span>
                                                <app-icon name="fas-info-circle"
                                                          [title]="'In the possible absence of monitored data, manually uploaded data are shown. In the absence of monitored or uploaded data, the graph shows data from statistical profiles.'|i18n">
                                                </app-icon>
                                            </ng-container>
                                            <ng-container *ngIf="dataType === MeasureDataType.STATISTICAL">
                                                <span>{{ 'Hand-loaded'|i18n }}</span>
                                                <app-icon name="fas-info-circle"
                                                          [title]="'If there is no manually uploaded data, the graph shows data from statistical profiles.'|i18n">
                                                </app-icon>
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                    <ng-container *ngIf="!isEcSelected">
                                        <ng-container *appVar="isDefined(meas.dataType) ? meas.dataType : measuresType as dataType">
                                            <div *ngIf="dataType === MeasureDataType.MONITORED" fxLayout="row" fxLayoutAlign="start center"
                                                 fxLayoutGap="0.25rem"
                                                 class="legend-toggle" [class.legend-hidden]="isLegendEntryHidden(meas.name, MeasureAggregationDataSource.METER)"
                                                 (click)="toggleOrigin(meas.name, MeasureAggregationDataSource.METER)">
                                                <span [style]="{'background-color': measData[0].color}" class="legend-line"></span>
                                                <span>{{ 'Monitored'|i18n }}</span>
                                            </div>
                                        </ng-container>
                                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.25rem"
                                             class="legend-toggle" [class.legend-hidden]="isLegendEntryHidden(meas.name, MeasureAggregationDataSource.FILE)"
                                             (click)="toggleOrigin(meas.name, MeasureAggregationDataSource.FILE)">
                                            <span [style]="{'background-color': measData[0].color}" class="legend-line manual"></span>
                                            <span>{{ 'Hand-loaded'|i18n }}</span>
                                        </div>
                                    </ng-container>
                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.25rem"
                                         class="legend-toggle" [class.legend-hidden]="isLegendEntryHidden(meas.name, MeasureAggregationDataSource.PROFILE)"
                                         (click)="toggleOrigin(meas.name, MeasureAggregationDataSource.PROFILE)">
                                        <span [style]="{'background-color': measData[0].color}" class="legend-line dashed"></span>
                                        <span>{{ 'Statistical'|i18n }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="measure-chart">
                                <app-line-chart
                                        *ngIf="mkChartLines(measData, meas.name).length; else allSeriesHidden"
                                        [data]="mkChartLines(measData, meas.name)"
                                        [margins]="{left: 65, right: -20, top: 10, bottom: 35}"
                                        [yTickFormatter]="getUom(measData)|yTickFormatter"
                                        [tooltipFormatter]="getUom(measData)|tooltipFormatter:timeResolution.resolution*60000"
                                        [xGrid]="true"
                                        [yGrid]="true"
                                        [gridColor]="gridColor"
                                        [tooltipBorderColor]="tooltipBorderColor"
                                        [tooltipBackgroundColor]="tooltipBackgroundColor"
                                        [selectionLineColor]="selectionLineColor"
                                        [xTickSpace]="80"
                                        [yTickSpace]="30"
                                        [enableZoom]="true"
                                        [enableSelection]="true"
                                        (selection)="onSelectTimeRangeFromChart($event)"
                                        [resizeTrigger]="contentResize">
                                </app-line-chart>
                                <!-- @PoweredByAi(date="2026-06-25", model="claude-opus-4-8") — empty state when every
                                     series has been toggled off from the legend, instead of a blank chart (ETT-1161). -->
                                <ng-template #allSeriesHidden>
                                    <div *ngIf="anyOriginHidden(meas.name)" fxLayout="row" fxLayoutAlign="center center"
                                         class="measure-no-visible-series">
                                        <app-icon name="fal-exclamation-circle"></app-icon>&nbsp;
                                        <span class="pl-8">{{ 'All series are hidden'|i18n }}</span>
                                    </div>
                                </ng-template>
                            </div>
                        </ng-container>
                        <div *ngIf="!!measData && isEmpty(measData)" fxLayout="row" fxLayoutAlign="center center">
                            <app-icon name="fal-exclamation-circle"></app-icon>&nbsp;
                            <span class="pl-8">{{ 'No data'|i18n }}</span>
                        </div>
                        <div *ngIf="!measData" fxLayout="row" fxLayoutAlign="center" class="measure-loading">
                            <mat-spinner diameter="20"></mat-spinner>
                            <span class="pl-8">{{ 'Loading data'|i18n }}...</span>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="!!templateData" class="download-template-button" fxLayoutAlign="end center">
                <button app-ghost-button
                        [disabled]="downloadingTemplate"
                        (click)="exportMeasuresToExcel()">
                    <app-icon name="fal-file-excel"></app-icon>
                    {{ 'Export to Excel'|i18n }}
                </button>
            </div>
        </div>
    </div>
</div>


<ng-template #uploadMeasures let-data let-close="close">
    <div fxLayout="column" fxLayoutAlign="center center">
        <div class="app-dialog-background" fxLayout="row" fxLayoutAlign="center center">
            <app-measures-upload
                    [resource]="mkDialogData()">
            </app-measures-upload>
        </div>
    </div>
</ng-template>


<ng-template #uploadGSEMeasures let-data let-close="close">
    <div fxLayout="column" fxLayoutAlign="center center">
        <div class="app-dialog-background" fxLayout="row" fxLayoutAlign="center center">
            <app-gse-upload [resource]="mkDialogData()"
                            (dataUploaded)="onDataUpload()">
            </app-gse-upload>
        </div>
    </div>
</ng-template>


<ng-template #deleteGSEData let-data let-close="close">
    <div fxLayout="column" fxLayoutAlign="center center">
        <div class="app-dialog-background" fxLayout="row" fxLayoutAlign="center center">
            <app-gse-delete [activeMonths]="activeMonths"
                            (yearAndMonth)="data.yearAndMonth = $event"
                            (valid)="data.valid = $event">
            </app-gse-delete>
        </div>
    </div>
    <div fxLayout="column" fxLayoutAlign="center center" class="mt-24">
        <div fxLayout="row" fxLayoutAlign="center start" fxLayoutGap="48px">
            <button app-ghost-button (click)="close(false)">
                {{ 'Cancel'|i18n }}
            </button>
            <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
                <button app-ghost-button class="app-button-alert"
                        [disabled]="!data.valid || !data.yearAndMonth"
                        (click)="close(data.yearAndMonth)">
                    {{ 'Delete data'|i18n }}
                </button>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #spinner let-data="data" let-close="close">
    <app-spinner [spinnerDataSubj]="data"
                 (closeSpinner)="close()">
    </app-spinner>
</ng-template>
